<footer class="text-center text-lg-start mt-2 mb-2">
  <hr />
  <section class="justify-content-center">
    <div class="d-flex row justify-content-center text-center pt-2" *ngIf="about$ | async as about">
      <div class="text-center fw-bold mb-2" *ngIf="about.mainTitle" [innerHTML]="about.mainTitle | safeHtml"></div>
      <div class="text-center fw-bold mb-2" *ngIf="about.contactTitle" [innerHTML]="about.contactTitle | safeHtml">
      </div>
      <p *ngIf="about.contact" class="mb-2" [innerHTML]="about.contact | safeHtml"></p>
      <div>
        <div class="text-center fw-bold mb-2" *ngIf="about.instructionTitle"
          [innerHTML]="about.instructionTitle | safeHtml"></div>
        <div class="d-flex justify-content-center align-items-center mt-2"
          *ngIf="about.instructionsFirstPhrase != null">
          <span [innerHTML]="about.instructionsFirstPhrase | safeHtml"></span>&nbsp;<a
            [class.disabled-link]="!about.instructionsFirstPdfFile" [class.underline]="about.instructionsFirstPdfFile"
            (click)="
              about.instructionsFirstPdfFile != null
                ? pdfExport(about?.instructionsFirstPdfFile?.id)
                : null
            " class="text-reset" [innerHTML]="about.instructionsFirstFileTitle != null ? about.instructionsFirstFileTitle : '' | safeHtml"></a>
        </div>
        <div class="d-flex justify-content-center align-items-center" *ngIf="about.instructionsSecondPhrase != null">
          <span [innerHTML]="about.instructionsSecondPhrase | safeHtml"></span>
          &nbsp;<a [class.disabled-link]="!about.instructionsSecondPdfFile"
            [class.underline]="about.instructionsSecondPdfFile" (click)="
              about.instructionsSecondPdfFile != null
                ? pdfExport(about?.instructionsSecondPdfFile?.id)
                : null
            " class="text-reset" [innerHTML]="about.instructionsSecondFileTitle != null ? about.instructionsSecondFileTitle : '' | safeHtml"></a>
        </div>
      </div>
      <div class="mt-3" *ngIf="about.aboutFreeText">
        <p [innerHTML]="about.aboutFreeText | safeHtml"></p>
      </div>
      <div class="mt-2">
        <a [class.disabled-link]="!about.impressumPdfFile" [class.underline]="about.impressumPdfFile" (click)="
            about.impressumPdfFile != null
              ? pdfExport(about?.impressumPdfFile?.id)
              : null
          " class="text-reset">{{ "Footer.Impressum" | translate }}</a>
        <span>&nbsp;|&nbsp;</span>
        <a [class.disabled-link]="!about.dataProtectionPdfFile" [class.underline]="about.dataProtectionPdfFile" (click)="
            about.dataProtectionPdfFile != null
              ? pdfExport(about?.dataProtectionPdfFile?.id)
              : null
          " class="text-reset">{{ "Footer.DataProtection" | translate }}</a>
        <span>&nbsp;|&nbsp;</span>
        <a href="https://www.sg.ch/f/datenschutz-sg-ch.html" target="_blank" class="text-reset">{{ "Footer.DataProtectionSG" | translate }}</a>
      </div>
    </div>
  </section>
</footer>